import React, { useEffect, useState } from 'react';
import SalesPage from '../pages/SalesPage';
import DEFAULT_CONTENT from '../content/PAGE_CONTENT.json';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

function getOrSetArm() {
  let arm = getCookie('pr_ab');
  if (arm !== 'A' && arm !== 'B') {
    arm = Math.random() < 0.5 ? 'A' : 'B';
    document.cookie = `pr_ab=${arm}; max-age=${30 * 86400}; path=/; samesite=lax`;
  }
  return arm;
}

/**
 * Wraps the exported SalesPage: resolves CMS content + active timer from the
 * backend, silently falling back to the bundled PAGE_CONTENT.json on failure.
 * Handles the cookie-based 50/50 hero A/B assignment on the main sales page.
 */
export default function SalesRoute({ slug, variant }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const isTestPage = slug === 'performance-reset' || slug === 'home';
    const arm = isTestPage ? getOrSetArm() : null;

    (async () => {
      try {
        const r = await fetch(`${BACKEND}/api/page/resolve?slug=${encodeURIComponent(slug)}${arm ? `&arm=${arm}` : ''}`);
        if (!r.ok) return;
        const data = await r.json();
        // Bundled copy is the safety net: any section missing from the API never blanks the page.
        const resolved = { ...DEFAULT_CONTENT, ...data.content };
        try {
          const t = await fetch(`${BACKEND}/api/timers/current?slug=${encodeURIComponent(slug)}`);
          if (t.ok) {
            const timer = await t.json();
            if (timer.deadline_iso || timer.coupon_code) {
              resolved.pricing = {
                ...resolved.pricing,
                ...(timer.deadline_iso ? { deadline_iso: timer.deadline_iso } : {}),
                ...(timer.coupon_code ? { coupon_code: timer.coupon_code } : {}),
              };
            }
          }
        } catch (e) { /* timer fallback: bundled content */ }
        if (arm) {
          fetch(`${BACKEND}/api/analytics/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ page: window.location.pathname, variant, event: 'ab_exposure', arm }),
          }).catch(() => {});
        }
        if (!cancelled) setContent(resolved);
      } catch (e) { /* bundled fallback */ }
    })();
    return () => { cancelled = true; };
  }, [slug, variant]);

  return <SalesPage content={content || undefined} variant={variant} arm={getCookie('pr_ab') || ''} />;
}
